import axios from "axios";
import API_BASE_URL from "./BaseApiUrl";

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("userDetails"); // or your key

    if (token) {
      const parsedToken = JSON.parse(token);
      config.headers.Authorization = `Bearer ${parsedToken.access_token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export default api;
